<a nz-button nzSize="large" [href]="link" [nzBlock]="fullSize" target="_blank">
  {{ 'NOTATIONS' | translate }}
  <i nz-icon nzType="info-circle" nzTheme="outline"></i>
</a>
